export const CHANNEL_LOGO_SIZE_MULTIPLIER = 0.4;
